var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiRepoLogoWithText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 455 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7.56983,-5.33276)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.1,202.7L364.1,202.7L358.6,216.6L355.6,216.6L371.5,177L373.3,177L388.8,216.6L385.7,216.6L380.1,202.7ZM365.1,200.2L379.2,200.2L373.8,186C373.3,184.9 372.8,183.3 372.2,181.4C371.7,183.1 371.2,184.7 370.6,186.1L365.1,200.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.6,199.4L404.6,216.6L401.8,216.6L401.8,177.2L411.2,177.2C416.1,177.2 419.7,178.1 422,179.9C424.3,181.7 425.5,184.4 425.5,188.1C425.5,190.7 424.8,193 423.4,194.8C422,196.6 419.9,197.9 417,198.7L427.7,216.7L424.4,216.7L414.2,199.5L404.6,199.4ZM404.6,197L412.1,197C415.4,197 418,196.3 419.8,194.8C421.6,193.3 422.6,191.1 422.6,188.2C422.6,185.2 421.7,183 419.9,181.6C418.1,180.2 415.2,179.5 411.1,179.5L404.6,179.5L404.6,197Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.3,179.1C452.4,179.1 448.5,180.7 445.6,183.8C442.7,186.9 441.3,191.3 441.3,196.8C441.3,202.4 442.6,206.8 445.3,209.9C448,213 451.8,214.6 456.8,214.6C460.1,214.6 463.1,214.2 465.9,213.3L465.9,215.7C463.3,216.6 460,217.1 456.1,217.1C450.6,217.1 446.2,215.3 443,211.7C439.8,208.1 438.2,203.1 438.2,196.7C438.2,192.7 439,189.2 440.5,186.1C442,183 444.2,180.7 447.1,179C449.9,177.3 453.3,176.5 457,176.5C460.8,176.5 464.3,177.2 467.3,178.7L466.2,181.2C463.5,179.8 460.5,179.1 457.3,179.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.4,216.6L505.6,216.6L505.6,197.2L482.6,197.2L482.6,216.6L479.8,216.6L479.8,177.2L482.6,177.2L482.6,194.7L505.6,194.7L505.6,177.2L508.4,177.2L508.4,216.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.1,
    y: 177.2,
    width: 2.8,
    height: 39.4,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.9,200.9L560.9,216.6L554.5,216.6L554.5,177.2L565.6,177.2C570.7,177.2 574.5,178.2 576.9,180.1C579.3,182 580.6,184.9 580.6,188.7C580.6,193.6 578,197.1 572.9,199.2L584,216.6L576.7,216.6L567.3,200.9L560.9,200.9ZM560.9,195.5L565.4,195.5C568.4,195.5 570.6,194.9 571.9,193.8C573.2,192.7 573.9,191 573.9,188.8C573.9,186.6 573.2,185 571.7,184C570.2,183 568.1,182.5 565.1,182.5L560.8,182.5L560.9,195.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.6,216.6L597.3,216.6L597.3,177.2L619.6,177.2L619.6,182.6L603.7,182.6L603.7,193.3L618.6,193.3L618.6,198.7L603.7,198.7L603.7,211.1L619.6,211.1L619.6,216.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.9,189.1C660.9,193.2 659.6,196.4 656.9,198.6C654.2,200.8 650.4,201.9 645.4,201.9L641.3,201.9L641.3,216.7L634.9,216.7L634.9,177.3L646.3,177.3C651.2,177.3 654.9,178.3 657.4,180.3C659.7,182.2 660.9,185.2 660.9,189.1ZM641.3,196.4L644.7,196.4C648,196.4 650.4,195.8 652,194.7C653.5,193.6 654.3,191.8 654.3,189.3C654.3,187 653.6,185.3 652.2,184.2C650.8,183.1 648.7,182.5 645.7,182.5L641.2,182.5L641.3,196.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.4,196.8C709.4,203.2 707.8,208.2 704.6,211.8C701.4,215.4 696.8,217.1 691,217.1C685,217.1 680.5,215.3 677.3,211.8C674.1,208.3 672.5,203.2 672.5,196.7C672.5,190.2 674.1,185.2 677.3,181.7C680.5,178.2 685.1,176.5 691,176.5C696.9,176.5 701.4,178.3 704.6,181.8C707.8,185.4 709.4,190.4 709.4,196.8ZM679.3,196.8C679.3,201.7 680.3,205.3 682.2,207.8C684.2,210.3 687.1,211.6 690.9,211.6C694.7,211.6 697.6,210.4 699.6,207.9C701.6,205.4 702.5,201.7 702.5,196.8C702.5,192 701.5,188.3 699.6,185.8C697.7,183.3 694.8,182.1 691,182.1C687.1,182.1 684.2,183.3 682.2,185.8C680.3,188.3 679.3,192 679.3,196.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.7,236.8C359.3,236.8 358.2,236.4 357.5,235.5C356.8,234.6 356.3,233.5 356.3,231.9C356.3,230.4 356.7,229.2 357.4,228.3C358.1,227.4 359.2,226.9 360.4,226.9C361.5,226.9 362.4,227.3 363,228.1C363.6,228.9 364,229.9 364,231.3L364,232L357.2,232C357.2,233.3 357.5,234.3 358.1,235C358.7,235.7 359.6,236 360.7,236C361.2,236 361.7,236 362.1,235.9C362.5,235.8 363,235.7 363.7,235.4L363.7,236.2C363.2,236.4 362.7,236.6 362.2,236.7C361.8,236.7 361.3,236.8 360.7,236.8ZM360.5,227.7C359.6,227.7 358.9,228 358.3,228.6C357.7,229.2 357.4,230.1 357.3,231.2L363.2,231.2C363.2,230.1 363,229.2 362.5,228.6C362,228 361.3,227.7 360.5,227.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.7,236.6L375.7,230.4C375.7,229.4 375.5,228.8 375.1,228.3C374.7,227.9 374.1,227.7 373.2,227.7C372.1,227.7 371.2,228 370.7,228.6C370.2,229.2 369.9,230.1 369.9,231.4L369.9,236.6L369,236.6L369,227.1L369.7,227.1L369.9,228.4L370,228.4C370.6,227.4 371.7,226.9 373.3,226.9C375.5,226.9 376.5,228.1 376.5,230.4L376.5,236.6L375.7,236.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.5,236C385,236 385.5,236 385.9,235.9L385.9,236.6C385.5,236.7 385,236.8 384.4,236.8C383.6,236.8 382.9,236.6 382.5,236.1C382.1,235.6 381.9,234.9 381.9,234L381.9,227.9L380.5,227.9L380.5,227.4L381.9,227L382.3,224.8L382.7,224.8L382.7,227.1L385.5,227.1L385.5,227.9L382.7,227.9L382.7,233.9C382.7,234.6 382.8,235.2 383.1,235.5C383.5,235.8 383.9,236 384.5,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.1,236.8C392.7,236.8 391.6,236.4 390.9,235.5C390.2,234.6 389.7,233.5 389.7,231.9C389.7,230.4 390.1,229.2 390.8,228.3C391.5,227.4 392.6,226.9 393.8,226.9C394.9,226.9 395.8,227.3 396.4,228.1C397,228.9 397.4,229.9 397.4,231.3L397.4,232L390.6,232C390.6,233.3 390.9,234.3 391.5,235C392.1,235.7 393,236 394.1,236C394.6,236 395.1,236 395.5,235.9C395.9,235.8 396.4,235.7 397.1,235.4L397.1,236.2C396.6,236.4 396.1,236.6 395.6,236.7C395.2,236.7 394.7,236.8 394.1,236.8ZM393.9,227.7C393,227.7 392.3,228 391.7,228.6C391.1,229.2 390.8,230.1 390.7,231.2L396.6,231.2C396.6,230.1 396.4,229.2 395.9,228.6C395.4,228 394.7,227.7 393.9,227.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.2,226.9C406.6,226.9 407,226.9 407.5,227L407.3,227.8C406.9,227.7 406.5,227.7 406.1,227.7C405.3,227.7 404.6,228 404.1,228.7C403.6,229.4 403.3,230.3 403.3,231.3L403.3,236.5L402.4,236.5L402.4,227L403.1,227L403.2,228.7L403.3,228.7C403.7,228 404.1,227.5 404.5,227.2C405,227 405.6,226.9 406.2,226.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.8,236.8C414.3,236.8 413.3,236.3 412.6,235.2L412.5,235.2L412.5,240.9L411.6,240.9L411.6,227.1L412.3,227.1L412.5,228.5L412.6,228.5C413.3,227.5 414.3,227 415.7,227C417,227 418,227.4 418.6,228.3C419.3,229.1 419.6,230.4 419.6,232C419.6,233.6 419.2,234.8 418.5,235.6C418,236.3 417,236.8 415.8,236.8ZM415.8,236C416.8,236 417.5,235.6 418.1,234.9C418.6,234.2 418.9,233.2 418.9,231.9C418.9,229.1 417.9,227.7 415.9,227.7C414.8,227.7 414,228 413.5,228.6C413,229.2 412.7,230.2 412.7,231.6L412.7,231.9C412.7,233.4 412.9,234.4 413.4,235.1C413.9,235.7 414.7,236 415.8,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.5,226.9C428.9,226.9 429.3,226.9 429.8,227L429.6,227.8C429.2,227.7 428.8,227.7 428.4,227.7C427.6,227.7 426.9,228 426.4,228.7C425.9,229.4 425.6,230.3 425.6,231.3L425.6,236.5L424.7,236.5L424.7,227L425.4,227L425.5,228.7L425.6,228.7C426,228 426.4,227.5 426.8,227.2C427.3,227 427.8,226.9 428.5,226.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.9,224.4C433.9,223.8 434.1,223.6 434.5,223.6C434.7,223.6 434.8,223.7 434.9,223.8C435,223.9 435.1,224.2 435.1,224.4C435.1,224.7 435,224.9 434.9,225C434.8,225.1 434.7,225.2 434.5,225.2C434.1,225.3 433.9,225 433.9,224.4ZM434.9,236.6L434,236.6L434,227.1L434.9,227.1L434.9,236.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.3,234.1C446.3,235 446,235.6 445.3,236.1C444.7,236.6 443.7,236.8 442.5,236.8C441.2,236.8 440.2,236.6 439.5,236.2L439.5,235.3C440.5,235.8 441.5,236 442.5,236C443.4,236 444.2,235.8 444.6,235.5C445.1,235.2 445.3,234.8 445.3,234.3C445.3,233.8 445.1,233.4 444.7,233.1C444.3,232.8 443.7,232.5 442.8,232.1C441.8,231.8 441.2,231.5 440.8,231.2C440.4,230.9 440.1,230.7 439.9,230.4C439.7,230.1 439.6,229.7 439.6,229.3C439.6,228.6 439.9,228 440.5,227.6C441.1,227.2 441.9,227 443,227C444,227 445,227.2 445.9,227.6L445.6,228.4C444.7,228 443.8,227.8 443,227.8C442.2,227.8 441.6,227.9 441.2,228.2C440.7,228.5 440.5,228.8 440.5,229.3C440.5,229.8 440.7,230.2 441,230.5C441.4,230.8 442,231.1 443.1,231.5C444,231.8 444.6,232.1 445,232.3C445.4,232.5 445.7,232.8 445.9,233.1C446.2,233.3 446.3,233.7 446.3,234.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.9,236.8C453.5,236.8 452.4,236.4 451.7,235.5C451,234.6 450.5,233.5 450.5,231.9C450.5,230.4 450.9,229.2 451.6,228.3C452.3,227.4 453.4,226.9 454.6,226.9C455.7,226.9 456.6,227.3 457.2,228.1C457.8,228.9 458.2,229.9 458.2,231.3L458.2,232L451.4,232C451.4,233.3 451.7,234.3 452.3,235C452.9,235.7 453.8,236 454.9,236C455.4,236 455.9,236 456.3,235.9C456.7,235.8 457.2,235.7 457.9,235.4L457.9,236.2C457.4,236.4 456.9,236.6 456.4,236.7C456,236.7 455.5,236.8 454.9,236.8ZM454.7,227.7C453.8,227.7 453.1,228 452.5,228.6C451.9,229.2 451.6,230.1 451.5,231.2L457.4,231.2C457.4,230.1 457.2,229.2 456.7,228.6C456.2,228 455.5,227.7 454.7,227.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476,236.6L475.8,235.1L475.7,235.1C475.2,235.7 474.7,236.1 474.2,236.4C473.7,236.7 473.1,236.8 472.4,236.8C471.5,236.8 470.7,236.6 470.2,236.1C469.7,235.6 469.4,235 469.4,234.1C469.4,233.2 469.8,232.5 470.6,231.9C471.4,231.4 472.5,231.1 474,231.1L475.8,231L475.8,230.4C475.8,229.5 475.6,228.8 475.2,228.4C474.8,227.9 474.2,227.7 473.4,227.7C472.5,227.7 471.6,227.9 470.7,228.4L470.4,227.6C471.4,227.1 472.5,226.9 473.5,226.9C474.5,226.9 475.3,227.2 475.8,227.7C476.3,228.2 476.6,229.1 476.6,230.2L476.6,236.5L476,236.5L476,236.6ZM472.5,236C473.5,236 474.3,235.7 474.9,235.1C475.5,234.5 475.8,233.7 475.8,232.7L475.8,231.8L474.1,231.9C472.8,232 471.8,232.2 471.2,232.5C470.6,232.9 470.3,233.4 470.3,234.1C470.3,234.7 470.5,235.2 470.8,235.5C471.3,235.8 471.8,236 472.5,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.8,226.9C486.2,226.9 486.6,226.9 487.1,227L486.9,227.8C486.5,227.7 486.1,227.7 485.7,227.7C484.9,227.7 484.2,228 483.7,228.7C483.2,229.4 482.9,230.3 482.9,231.3L482.9,236.5L482,236.5L482,227L482.7,227L482.8,228.7L482.9,228.7C483.3,228 483.7,227.5 484.1,227.2C484.5,226.9 485.1,226.9 485.8,226.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.1,236.8C493.7,236.8 492.7,236.4 491.9,235.5C491.1,234.6 490.7,233.4 490.7,231.9C490.7,230.3 491.1,229.1 491.9,228.2C492.7,227.3 493.8,226.9 495.2,226.9C496,226.9 496.8,227 497.6,227.3L497.4,228.1C496.6,227.8 495.9,227.7 495.3,227.7C494.1,227.7 493.3,228.1 492.7,228.8C492.1,229.5 491.8,230.6 491.8,231.9C491.8,233.2 492.1,234.2 492.7,234.9C493.3,235.6 494.1,236 495.2,236C496.1,236 496.9,235.8 497.6,235.5L497.6,236.3C496.9,236.6 496.1,236.8 495.1,236.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.8,236.6L508.8,230.4C508.8,229.4 508.6,228.8 508.2,228.3C507.8,227.9 507.2,227.7 506.3,227.7C505.2,227.7 504.3,228 503.8,228.6C503.3,229.2 503,230.1 503,231.4L503,236.6L502.1,236.6L502.1,223L503,223L503,228.5L503.1,228.5C503.5,227.9 503.9,227.5 504.4,227.3C504.9,227 505.6,226.9 506.4,226.9C508.6,226.9 509.6,228.1 509.6,230.4L509.6,236.6L508.8,236.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.9,224.4C514.9,223.8 515.1,223.6 515.5,223.6C515.7,223.6 515.8,223.7 515.9,223.8C516,223.9 516.1,224.2 516.1,224.4C516.1,224.7 516,224.9 515.9,225C515.8,225.1 515.7,225.2 515.5,225.2C515.1,225.3 514.9,225 514.9,224.4ZM515.9,236.6L515,236.6L515,227.1L515.9,227.1L515.9,236.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524,236C524.5,236 525,236 525.4,235.9L525.4,236.6C525,236.7 524.5,236.8 523.9,236.8C523.1,236.8 522.4,236.6 522,236.1C521.6,235.7 521.4,234.9 521.4,234L521.4,227.9L520,227.9L520,227.4L521.4,227L521.8,224.8L522.2,224.8L522.2,227.1L525,227.1L525,227.9L522.2,227.9L522.2,233.9C522.2,234.6 522.3,235.2 522.6,235.5C523,235.8 523.4,236 524,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.6,236.8C532.2,236.8 531.1,236.4 530.4,235.5C529.6,234.6 529.2,233.5 529.2,231.9C529.2,230.4 529.6,229.2 530.3,228.3C531,227.4 532.1,226.9 533.3,226.9C534.4,226.9 535.3,227.3 536,228.1C536.6,228.9 537,229.9 537,231.3L537,232L530.2,232C530.2,233.3 530.5,234.3 531.1,235C531.7,235.7 532.6,236 533.7,236C534.2,236 534.7,236 535.1,235.9C535.5,235.8 536,235.7 536.7,235.4L536.7,236.2C536.2,236.4 535.7,236.6 535.2,236.7C534.7,236.7 534.2,236.8 533.6,236.8ZM533.4,227.7C532.5,227.7 531.7,228 531.2,228.6C530.6,229.2 530.3,230.1 530.2,231.2L536.1,231.2C536.1,230.1 535.9,229.2 535.4,228.6C534.9,228 534.2,227.7 533.4,227.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.7,236.8C544.3,236.8 543.3,236.4 542.5,235.5C541.7,234.6 541.3,233.4 541.3,231.9C541.3,230.3 541.7,229.1 542.5,228.2C543.3,227.3 544.4,226.9 545.8,226.9C546.6,226.9 547.4,227 548.2,227.3L548,228.1C547.2,227.8 546.5,227.7 545.9,227.7C544.7,227.7 543.9,228.1 543.3,228.8C542.7,229.5 542.4,230.6 542.4,231.9C542.4,233.2 542.7,234.2 543.3,234.9C543.9,235.6 544.7,236 545.8,236C546.7,236 547.5,235.8 548.2,235.5L548.2,236.3C547.5,236.6 546.7,236.8 545.7,236.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.3,236C555.8,236 556.3,236 556.7,235.9L556.7,236.6C556.3,236.7 555.8,236.8 555.2,236.8C554.4,236.8 553.7,236.6 553.3,236.1C552.9,235.7 552.7,234.9 552.7,234L552.7,227.9L551.3,227.9L551.3,227.4L552.7,227L553.1,224.8L553.5,224.8L553.5,227.1L556.3,227.1L556.3,227.9L553.5,227.9L553.5,233.9C553.5,234.6 553.6,235.2 553.9,235.5C554.3,235.8 554.7,236 555.3,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.8,227.1L561.8,233.3C561.8,234.3 562,235 562.4,235.4C562.8,235.8 563.4,236.1 564.3,236.1C565.4,236.1 566.3,235.8 566.8,235.2C567.3,234.6 567.6,233.7 567.6,232.4L567.6,227.2L568.5,227.2L568.5,236.7L567.8,236.7L567.6,235.4L567.5,235.4C566.9,236.4 565.8,236.9 564.2,236.9C562,236.9 561,235.7 561,233.4L561,227.2L561.8,227.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.7,226.9C578.1,226.9 578.5,226.9 579,227L578.8,227.8C578.4,227.7 578,227.7 577.6,227.7C576.8,227.7 576.1,228 575.6,228.7C575.1,229.4 574.8,230.3 574.8,231.3L574.8,236.5L574,236.5L574,227L574.7,227L574.8,228.7L574.9,228.7C575.3,228 575.7,227.5 576.2,227.2C576.6,227 577.1,226.9 577.7,226.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.1,236.8C585.7,236.8 584.6,236.4 583.9,235.5C583.1,234.6 582.7,233.5 582.7,231.9C582.7,230.4 583.1,229.2 583.8,228.3C584.5,227.4 585.6,226.9 586.8,226.9C587.9,226.9 588.8,227.3 589.4,228.1C590,228.9 590.4,229.9 590.4,231.3L590.4,232L583.6,232C583.6,233.3 583.9,234.3 584.5,235C585.1,235.7 586,236 587.1,236C587.6,236 588.1,236 588.5,235.9C588.9,235.8 589.4,235.7 590.1,235.4L590.1,236.2C589.6,236.4 589.1,236.6 588.6,236.7C588.2,236.7 587.7,236.8 587.1,236.8ZM586.9,227.7C586,227.7 585.2,228 584.7,228.6C584.1,229.2 583.8,230.1 583.7,231.2L589.6,231.2C589.6,230.1 589.4,229.2 588.9,228.6C588.4,228 587.7,227.7 586.9,227.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.2,226.9C606.6,226.9 607,226.9 607.5,227L607.3,227.8C606.9,227.7 606.5,227.7 606.1,227.7C605.3,227.7 604.6,228 604.1,228.7C603.6,229.4 603.3,230.3 603.3,231.3L603.3,236.5L602.4,236.5L602.4,227L603.1,227L603.2,228.7L603.3,228.7C603.7,228 604.1,227.5 604.5,227.2C604.9,226.9 605.5,226.9 606.2,226.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.6,236.8C614.2,236.8 613.1,236.4 612.4,235.5C611.6,234.6 611.2,233.5 611.2,231.9C611.2,230.4 611.6,229.2 612.3,228.3C613,227.4 614.1,226.9 615.3,226.9C616.4,226.9 617.3,227.3 618,228.1C618.6,228.9 619,229.9 619,231.3L619,232L612.2,232C612.2,233.3 612.5,234.3 613.1,235C613.7,235.7 614.6,236 615.7,236C616.2,236 616.7,236 617.1,235.9C617.5,235.8 618,235.7 618.7,235.4L618.7,236.2C618.2,236.4 617.7,236.6 617.2,236.7C616.6,236.7 616.1,236.8 615.6,236.8ZM615.3,227.7C614.4,227.7 613.6,228 613.1,228.6C612.5,229.2 612.2,230.1 612.1,231.2L618,231.2C618,230.1 617.8,229.2 617.3,228.6C616.8,228 616.2,227.7 615.3,227.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628,236.8C626.5,236.8 625.5,236.3 624.8,235.2L624.7,235.2L624.7,240.9L623.8,240.9L623.8,227.1L624.5,227.1L624.7,228.5L624.8,228.5C625.5,227.5 626.5,227 627.9,227C629.2,227 630.2,227.4 630.8,228.3C631.5,229.1 631.8,230.4 631.8,232C631.8,233.6 631.4,234.8 630.7,235.6C630.1,236.3 629.2,236.8 628,236.8ZM627.9,236C628.9,236 629.6,235.6 630.2,234.9C630.8,234.2 631,233.2 631,231.9C631,229.1 630,227.7 628,227.7C626.9,227.7 626.1,228 625.6,228.6C625.1,229.2 624.8,230.2 624.8,231.6L624.8,231.9C624.8,233.4 625,234.4 625.5,235.1C626,235.7 626.8,236 627.9,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.7,231.8C644.7,233.4 644.3,234.6 643.6,235.4C642.8,236.3 641.8,236.7 640.5,236.7C639.7,236.7 638.9,236.5 638.3,236.1C637.7,235.7 637.2,235.1 636.8,234.4C636.4,233.7 636.3,232.8 636.3,231.8C636.3,230.2 636.7,229 637.4,228.2C638.2,227.3 639.2,226.9 640.5,226.9C641.8,226.9 642.8,227.3 643.6,228.2C644.4,229.1 644.7,230.3 644.7,231.8ZM637.2,231.8C637.2,233.1 637.5,234.1 638.1,234.9C638.7,235.6 639.5,236 640.5,236C641.6,236 642.4,235.6 642.9,234.9C643.5,234.2 643.8,233.1 643.8,231.8C643.8,230.5 643.5,229.5 642.9,228.7C642.3,227.9 641.5,227.6 640.5,227.6C639.5,227.6 638.6,228 638.1,228.7C637.5,229.5 637.2,230.5 637.2,231.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.6,234.1C655.6,235 655.3,235.6 654.6,236.1C654,236.6 653,236.8 651.8,236.8C650.5,236.8 649.5,236.6 648.8,236.2L648.8,235.3C649.8,235.8 650.8,236 651.8,236C652.7,236 653.5,235.8 653.9,235.5C654.4,235.2 654.6,234.8 654.6,234.3C654.6,233.8 654.4,233.4 654,233.1C653.6,232.8 653,232.5 652.1,232.1C651.1,231.8 650.5,231.5 650.1,231.2C649.7,230.9 649.4,230.7 649.2,230.4C649,230.1 648.9,229.7 648.9,229.3C648.9,228.6 649.2,228 649.8,227.6C650.4,227.2 651.2,227 652.3,227C653.3,227 654.3,227.2 655.2,227.6L654.9,228.4C654,228 653.1,227.8 652.3,227.8C651.5,227.8 650.9,227.9 650.5,228.2C650,228.5 649.8,228.8 649.8,229.3C649.8,229.8 650,230.2 650.3,230.5C650.7,230.8 651.3,231.1 652.4,231.5C653.3,231.8 653.9,232.1 654.3,232.3C654.7,232.5 655,232.8 655.2,233.1C655.5,233.3 655.6,233.7 655.6,234.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.3,224.4C660.3,223.8 660.5,223.6 660.9,223.6C661.1,223.6 661.2,223.7 661.3,223.8C661.4,223.9 661.5,224.2 661.5,224.4C661.5,224.7 661.4,224.9 661.3,225C661.2,225.1 661.1,225.2 660.9,225.2C660.4,225.3 660.3,225 660.3,224.4ZM661.2,236.6L660.3,236.6L660.3,227.1L661.2,227.1L661.2,236.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.3,236C669.8,236 670.3,236 670.7,235.9L670.7,236.6C670.3,236.7 669.8,236.8 669.2,236.8C668.4,236.8 667.7,236.6 667.3,236.1C666.9,235.7 666.7,234.9 666.7,234L666.7,227.9L665.3,227.9L665.3,227.4L666.7,227L667.1,224.8L667.5,224.8L667.5,227.1L670.3,227.1L670.3,227.9L667.5,227.9L667.5,233.9C667.5,234.6 667.6,235.2 667.9,235.5C668.3,235.8 668.7,236 669.3,236Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682.9,231.8C682.9,233.4 682.5,234.6 681.8,235.4C681,236.3 680,236.7 678.7,236.7C677.9,236.7 677.1,236.5 676.5,236.1C675.9,235.7 675.4,235.1 675,234.4C674.7,233.6 674.5,232.8 674.5,231.8C674.5,230.2 674.9,229 675.6,228.2C676.4,227.3 677.4,226.9 678.7,226.9C680,226.9 681,227.3 681.8,228.2C682.6,229.1 682.9,230.3 682.9,231.8ZM675.4,231.8C675.4,233.1 675.7,234.1 676.3,234.9C676.9,235.6 677.7,236 678.7,236C679.7,236 680.6,235.6 681.1,234.9C681.7,234.2 682,233.1 682,231.8C682,230.5 681.7,229.5 681.1,228.7C680.5,227.9 679.7,227.6 678.7,227.6C677.6,227.6 676.8,228 676.3,228.7C675.7,229.5 675.4,230.5 675.4,231.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.6,226.9C692,226.9 692.4,226.9 692.9,227L692.7,227.8C692.3,227.7 691.9,227.7 691.5,227.7C690.7,227.7 690,228 689.5,228.7C689,229.4 688.7,230.3 688.7,231.3L688.7,236.5L687.8,236.5L687.8,227L688.5,227L688.6,228.7L688.7,228.7C689.1,228 689.5,227.5 689.9,227.2C690.5,227 691,226.9 691.6,226.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695.6,227.1L696.5,227.1L698.5,232.4C699.1,234 699.5,235.1 699.7,235.7L699.8,235.7C700,234.9 700.4,233.8 701,232.3L703,227L703.9,227L699.6,238C699.3,238.9 699,239.5 698.7,239.8C698.5,240.1 698.2,240.4 697.9,240.5C697.6,240.6 697.2,240.7 696.8,240.7C696.5,240.7 696.1,240.6 695.7,240.5L695.7,239.7C696,239.8 696.4,239.8 696.8,239.8C697.1,239.8 697.4,239.7 697.6,239.6C697.8,239.5 698,239.2 698.2,238.9C698.4,238.6 698.6,238.1 698.8,237.5C699,236.9 699.2,236.4 699.3,236.3L695.6,227.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.1,169.8C325.7,169.8 329.4,173.5 329.4,178.1C329.4,181.3 327.6,184.1 325,185.5L325,234.3C327.5,235.7 329.1,238.4 329.1,241.5C329.1,246.1 325.4,249.8 320.8,249.8C316.2,249.8 312.5,246.1 312.5,241.5L312.5,241.4L270.4,217C269.2,217.7 267.8,218.1 266.2,218.1C261.6,218.1 257.9,214.4 257.9,209.8C257.9,205.2 261.6,201.5 266.2,201.5C267.7,201.5 269.1,201.9 270.3,202.6L312.8,177.9C312.9,173.4 316.6,169.8 321.1,169.8M321.1,167.1C315.6,167.1 311.1,171 310.2,176.3L270.2,199.5C268.9,199 267.6,198.8 266.2,198.8C260.1,198.8 255.2,203.8 255.2,209.8C255.2,215.8 260.2,220.8 266.2,220.8C267.6,220.8 269,220.5 270.2,220L309.8,242.9C310.5,248.3 315.2,252.4 320.7,252.4C326.8,252.4 331.7,247.4 331.7,241.4C331.7,238 330.1,234.9 327.6,232.8L327.6,187C330.4,184.9 332,181.7 332,178.2C332.2,172 327.2,167.1 321.1,167.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-247.63,-161.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.9,185.2L320.4,185.2C317.8,185.2 315.5,183.7 314.4,181.6L272.6,205.9C273.3,207 273.7,208.2 273.7,209.6C273.7,210.9 273.3,212.2 272.6,213.2L314.3,237.3C315.4,235 317.7,233.4 320.4,233.4L320.9,233.4L320.9,185.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiRepoLogoWithText);
export default __webpack_public_path__ + "static/media/ArchiREPO_logo_with_text.a49e2c8129812b68cd419805185b9057.svg";
export { ForwardRef as ReactComponent };